module.exports = "/_next/static/images/trezor_logo_vertical-b54f8bce4e1fb9b300e3665fd3907163.svg";